import { OrderGetResponseType } from "@sellar-io/api-v2/types";
import { ReactElement } from "react";
import { Dialog } from "../../../components/modal/Dialog";
import { CancelOrderDialogContent } from "./CancelOrderDialogContent";

export function CancelOrderDialog({
  active,
  order,
  onDismiss,
  onSubmit,
}: {
  active: boolean;
  order: OrderGetResponseType;
  onDismiss: () => void;
  onSubmit?: () => void;
}): ReactElement {
  return (
    <Dialog active={active} onDismiss={onDismiss}>
      <CancelOrderDialogContent
        order={order}
        onSubmit={onSubmit}
        onDismiss={onDismiss}
      />
    </Dialog>
  );
}
